'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BUTTON = exports.BUTTON = 'CMoleculeButton';
var CARD = exports.CARD = 'CMoleculeCard';
var CAROUSEL_CONTROLS = exports.CAROUSEL_CONTROLS = 'CCarouselControls';
var CAROUSEL_PAGE_CARD = exports.CAROUSEL_PAGE_CARD = 'CCarouselPageCard';
var CAROUSEL_PAGE_MEDIA = exports.CAROUSEL_PAGE_MEDIA = 'CCarouselPageMedia';
var CAROUSEL_PAGE_TEXT = exports.CAROUSEL_PAGE_TEXT = 'CCarouselPageText';
var CHECKBOX = exports.CHECKBOX = 'CMoleculeCheckbox';
var CTA_AREA = exports.CTA_AREA = 'CMoleculeCtaArea';
var DESKTOP_PLAYER = exports.DESKTOP_PLAYER = 'CMoleculeDesktopPlayer';
var MOBILE_PLAYER = exports.MOBILE_PLAYER = 'CMoleculeMobilePlayer';
var DIVIDER = exports.DIVIDER = 'CMoleculeDivider';
var FOOTER = exports.FOOTER = 'CMoleculeFooter';
var HEADER = exports.HEADER = 'CMoleculeHeader';
var ICON = exports.ICON = 'CMoleculeIcon';
var ILLUSTRATION = exports.ILLUSTRATION = 'CMoleculeIllustration';
var INPUT = exports.INPUT = 'CMoleculeInput';
var FULLSCREEN_CTA_BUTTON = exports.FULLSCREEN_CTA_BUTTON = 'CFullscreenCtaButton';
var MEDIA = exports.MEDIA = 'CMoleculeMedia';
var MEDIA_ANSWER = exports.MEDIA_ANSWER = 'CMoleculeMediaAnswer';
var SUBMIT = exports.SUBMIT = 'CMoleculeSubmit';
var TEXT = exports.TEXT = 'CMoleculeText';
var TEXT_ANSWER = exports.TEXT_ANSWER = 'CMoleculeTextAnswer';
var TEXT_DRAFT = exports.TEXT_DRAFT = 'CMoleculeTextDraft';
var TEXT_INPUT = exports.TEXT_INPUT = 'CMoleculeSmartTextInput';
var TEXTAREA = exports.TEXTAREA = 'CMoleculeTextarea';
var VIDEO_PREVIEW = exports.VIDEO_PREVIEW = 'CMoleculeVideoPreview';
var WEBINAR = exports.WEBINAR = 'CMoleculeWebinar';